import axios from 'axios';
import { inject } from 'vue';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AXIOS_SYMBOL = Symbol('axiosKey');
const KEBAB_REGEX = /\p{Lu}/gu;
// eslint-disable-next-line no-magic-numbers
const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
const format = (str) => {
    let formatted = str.replace(KEBAB_REGEX, match => `-${match}`);
    if (formatted.startsWith('-')) {
        // eslint-disable-next-line no-magic-numbers
        formatted = formatted.slice(1);
    }
    return capitalize(formatted);
};
export * from 'axios';
export default axios;
export function createAxios(headers, options) {
    const instance = axios.create();
    instance.updateCustomHeaders = (newHeaders) => {
        Object.entries(newHeaders).forEach(([key, value]) => {
            const formatted = format(key);
            const formattedKey = options?.legacy ? formatted : `X-${formatted}`;
            instance.defaults.headers.common[formattedKey] = value;
        });
    };
    instance.updateCustomHeaders(headers);
    return {
        install(app) {
            app.provide(AXIOS_SYMBOL, instance);
        },
        instance,
    };
}
export function useAxios() {
    const instance = inject(AXIOS_SYMBOL);
    if (!instance) {
        throw new Error('useAxios must be used within a provider.');
    }
    return instance;
}
//# sourceMappingURL=index.js.map